import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DatePicker as Picker, LocalizationProvider } from '@mui/lab';
import { TextField } from '@mui/material';
import { FC, useState } from 'react';
import { Workday } from '../models/workday';
import { SxProps } from '@mui/system';
import svLocale from 'date-fns/locale/sv';

type Props = {
  workdays: Workday[]
  handleDateChange: Function
}

const classes: SxProps = {
  datepicker: {
    color: '#ff0000'
  }
}

function sortByDueDate(workdays: Workday[]): void {
  workdays.sort((a: Workday, b: Workday) => {
    return +new Date(a.WdyDate) - +new Date(b.WdyDate)
  });
}
export const DatePicker: FC<Props> = ({ workdays, handleDateChange }) => {
  sortByDueDate(workdays)
  const startDate = new Date(workdays[0]?.WdyDate) ?? new Date(Date.now())
  const endDate = workdays?.length > 1 ? new Date(workdays.slice(-1)[0]?.WdyDate) : new Date(workdays[0]?.WdyDate) ?? new Date(Date.now())
  const [selectedDate, setSelectedDate] = useState(new Date(Date.now()))
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={svLocale}>
      <Picker
        label="Välj datum"
        inputFormat="eeee do MMMM"
        views={['day']}
        minDate={startDate}
        maxDate={endDate}
        value={selectedDate}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(date) => {
          handleDateChange(date as Date)
          setSelectedDate(date as Date)
        }}
        renderInput={(params) => {
          return (
            <TextField variant="standard" sx={classes.datepicker} {...params} onClick={(e) => setOpen(true)} />
          )
        }}      
      />
    </LocalizationProvider >
  )
}